<template>
  <div id="app">
    <!--根据路由更换的组件放在了router-view中，实现页面的跳转-->
    <AiHead></AiHead>
    <AIMenu v-if="!MenuFilters.includes(`${this.$router.history.current.name}`)"></AIMenu>
    <AiPersonalCenter></AiPersonalCenter>
    <router-view></router-view>
  </div>
</template>
<script>
  import AiHead from './components/AI-Head.vue'
  import AIMenu from './components/AI-Menu.vue'
  import AiPersonalCenter from './components/AI-Personal-Center.vue'
  // import AiPersonalOperate from './components/AI-Personal-Operate.vue'
  export default {
    name: 'App',
    components: {
      AiHead,
      AIMenu,
      AiPersonalCenter,
      // AiPersonalOperate,
    },
    data() {
      return {
        MenuFilters: ['Login', 'ResetPassword', 'Chat']
      };
    },
  }
</script>
<style>
@import url(./style/body.less);
</style>
